@if (dataJsonMenuOpt.length > 0) {
    <tec-item
        [tagImage]="{ icon: 'icon-back-ajax-result', status: 'level' }"
        [title]="'OPERATIONS.DETAIL.JSON' | translate"
        [clickeable]="false"
    >
        <tec-menu [options]="dataJsonMenuOpt" (valueChange)="dataJsonMenuChange($event)">
            <tec-button-icon [icon]="'icon-more'" [type]="'default'" />
        </tec-menu>
    </tec-item>
}

@if (showModalJsonViewer) {
    <app-modal-json-viewer
        [title]="'OPERATIONS.DETAIL.JSON' | translate"
        [json]="detail"
        (closeEvent)="showModalJsonViewer = false"
    />
}
